import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Card.module.css";

type CardVariant = "fixed" | "floating" | "collapsable";
type CardPadding = "none" | "medium" | "large";

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  variant?: CardVariant;
  padding?: CardPadding;
};

const Card = ({ children, className, padding = "medium", variant = "fixed", ...props }: CardProps) => (
  <div className={[styles.card, styles[variant], styles[`padding_${padding}`], className].filter(Boolean).join(" ")} {...props}>
    {children}
  </div>
);

export default Card;
